import React from 'react'
import { Route } from 'react-router-dom'
import EmailSuccess from './EmailSuccess';

import { emailSuccess } from "../../../constants/routePaths"

const EmailSuccessRoute = [
  <Route
    key="EmailSuccess"
    exact path={emailSuccess}
    component={EmailSuccess}
  />,
];

export default EmailSuccessRoute